import { Readable } from "node:stream";
import { a as waitUntilWorkflowInProgress, g as getWorkflowJob, p as pollWorkflowJob } from "../../../../../../../chunks/octokit.js";
import { u as updateInstallerProgress } from "../../../../../../../chunks/utils.js";
import { I as InstallerCollection } from "../../../../../../../chunks/firebase.js";
const GET = async ({ locals }) => {
  const installerRef = InstallerCollection().doc(locals.user?.email);
  const controller = new AbortController();
  const stream = new Readable({
    read() {
    },
    signal: controller.signal
  });
  const unsubscribe = installerRef.onSnapshot(
    (doc) => {
      const data = `event: update
data: ${JSON.stringify(doc.data())}

`;
      stream.push(data);
    },
    (error) => {
      const errorData = `event: error
data: ${JSON.stringify({ message: error.message })}

`;
      stream.push(errorData);
    }
  );
  waitUntilWorkflowInProgress(`user/${locals.user.email}`).then((workflow) => getWorkflowJob(workflow.id)).then(
    (job) => pollWorkflowJob(
      job.id,
      async ({ status, steps }) => {
        const completed = steps?.filter((step2) => step2.status === "completed").length;
        const step = steps?.find((step2) => step2.status === "in_progress")?.name;
        const total = steps?.length;
        const progress = `${completed} / ${total}`;
        const installerInfo = await installerRef.get();
        if (installerInfo.exists && !installerInfo?.data()?.cancelled) {
          updateInstallerProgress(locals.user.email, {
            progress,
            status,
            step: step ?? "None"
          });
        }
        if (!installerInfo.exists || status === "completed") {
          controller.abort();
        }
      },
      5e3,
      controller.signal
    )
  ).catch((err) => console.log(err));
  stream.on("close", () => {
    controller.abort();
    unsubscribe();
  });
  return new Response(stream, {
    headers: {
      "Content-Type": "text/event-stream",
      "Cache-Control": "no-cache",
      Connection: "keep-alive"
    }
  });
};
export {
  GET
};
